import { render, staticRenderFns } from "./VSwiperSlide.vue?vue&type=template&id=727fb646&"
import script from "./VSwiperSlide.vue?vue&type=script&lang=js&"
export * from "./VSwiperSlide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports